export default "__VITE_ASSET__BSqcUe0B__"